import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import {
    CartAddIcon,
    FlowerIcon,
    LoyaltyIcon,
    SecurityIcon,
    TrendingUpIcon,
    OnlineIcon,
} from '../icons';

import HeaderBox from '../header-box';
import './feature-grid.css';

const featuresList = [
    {
        icon: <CartAddIcon />,
        name: 'Point of Sale',
        link: '/dispensary-point-of-sale',
    },
    {
        icon: <OnlineIcon />,
        name: 'Online Ordering',
        link: '/cannabis-online-ordering',
    },
    {
        icon: <FlowerIcon />,
        name: 'Inventory',
        link: '/dispensary-inventory-and-compliance',
    },
    {
        icon: <SecurityIcon />,
        name: 'Compliance',
        link: '/dispensary-inventory-and-compliance',
    },

    {
        icon: <TrendingUpIcon />,
        name: 'Analytics',
        link: '/dispensary-analytics',
    },
    {
        icon: <LoyaltyIcon />,
        name: 'Loyalty',
        link: '/dispensary-loyalty-program',
    },
];

const Feature = ({ icon, name }) => (
    <div className="feature">
        {icon}
        <h2>{name}</h2>
    </div>
);

const FeatureGrid = ({ header }) => (
    <section className="feature-container">
        <HeaderBox header={header} />
        <div className="feature-grid">
            {featuresList.map(feature => (
                <Link key={feature.name} to={feature.link}>
                    <Feature icon={feature.icon} name={feature.name} />
                </Link>
            ))}
        </div>
    </section>
);

FeatureGrid.propTypes = {
    header: PropTypes.string,
};

export default FeatureGrid;
